export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.20-1243.59",
  commitId: "96ac876d3bf2f07a0fe039da10153e2e4b24b5ce",
  commitTime: "2026-10-20T12:43:59.000Z",
});
